import {
  combineDateAndTime,
  getNextQuarter,
  isMidnight,
} from "@circle-react/helpers/dateTimeHelpers";
import type { TimeValue } from "@circleco/compass/components/TimeInput";
import { isSameDay } from "date-fns";

export const ensureFuturePollCloseAt = (date: Date, time: TimeValue): Date => {
  const now = new Date();
  let combined = combineDateAndTime(date, time);

  if (isSameDay(combined, now) && isMidnight(combined)) {
    combined = getNextQuarter(now);
  }

  if (combined <= now) {
    return getNextQuarter(now);
  }

  return combined;
};
